import { Form, type FormProps } from "react-final-form";
import type { Matomo } from "../../types";

type FormWithTrackingProps = <
	FormValues = Record<string, any>,
	InitialFormValues = Partial<FormValues>,
>(
	props: FormProps<FormValues, InitialFormValues> & {
		matomoInstance?: Matomo;
	},
) => React.ReactElement;

export const FormWithTracking: FormWithTrackingProps = ({ ...rest }) => {
	return <Form {...rest} />;
};
